<template>
  <FloatInput class="app-float-input" outlined dense v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import FloatInput from '@/core/components/FloatInput'

export default {
  name: 'AppFloatInput',
  components: {
    FloatInput,
  },
}
</script>

<style scoped>
.app-float-input ::v-deep .v-input__slot {
  border-radius: 10px !important;
}

.app-float-input ::v-deep fieldset {
  border-radius: inherit !important;
}
</style>
